import Hierarchy from '@/views/Hierarchy'

import list from "@/views/Hierarchy/components/list";
import maintenance from "@/views/Hierarchy/components/maintenance";

export default {
    path: 'Hierarchy',
    name: 'Hierarchy',
    component: Hierarchy,
    children: [{
        path: '',
        name: 'hierarchy-list',
        component: list
    }, {
        path: 'Maintenance/:id',
        name: 'hierarchy-maintenance',
        component: maintenance
    }]
}